module.exports = __webpack_public_path__ + "img/code.1973b08e.png";